var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 6,
    viewBox: "0 0 22 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C1.34772 6 0 4.65228 0 3C0 1.34772 1.34772 0 3 0C4.65228 0 6 1.34772 6 3C6 4.65228 4.65228 6 3 6ZM2 3C2 3.54772 2.45228 4 3 4C3.54772 4 4 3.54772 4 3C4 2.45228 3.54772 2 3 2C2.45228 2 2 2.45228 2 3ZM11 6C9.34772 6 8 4.65228 8 3C8 1.34772 9.34772 0 11 0C12.6523 0 14 1.34772 14 3C14 4.65228 12.6523 6 11 6ZM10 3C10 3.54772 10.4523 4 11 4C11.5477 4 12 3.54772 12 3C12 2.45228 11.5477 2 11 2C10.4523 2 10 2.45228 10 3ZM19 6C17.3477 6 16 4.65228 16 3C16 1.34772 17.3477 0 19 0C20.6523 0 22 1.34772 22 3C22 4.65228 20.6523 6 19 6ZM18 3C18 3.54772 18.4523 4 19 4C19.5477 4 20 3.54772 20 3C20 2.45228 19.5477 2 19 2C18.4523 2 18 2.45228 18 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDots);
export default __webpack_public_path__ + "static/media/MoreDots.8d2c138c8bc6d58b797d31b0f71da435.svg";
export { ForwardRef as ReactComponent };